/* eslint-disable */
if (!localStorage.getItem('search-and-bookmark-data')) {
  localStorage.setItem('search-and-bookmark-data', JSON.stringify({
    pages: {
      key: 'title',
      data: [
                {
          title: 'Аналитика',
                    route: 'main',
                              icon: 'PieChartIcon',
                              isBookmarked: '',
                  },
                {
          title: 'Отчеты',
                    route: 'reports',
                              icon: 'MonitorIcon',
                              isBookmarked: '',
                  },
                {
          title: 'Проекты',
                    route: 'projects',
                              icon: 'BriefcaseIcon',
                              isBookmarked: '',
                  },
                {
          title: 'Документы',
                    route: 'docs',
                              icon: 'FileIcon',
                              isBookmarked: '',
                  },
              ]
    },
  }))
}
// prettier-ignore
export default [
    {
    title: 'Аналитика',
        route: 'main',
            icon: 'PieChartIcon',
          },
    {
    title: 'Отчеты',
        route: 'reports',
            icon: 'MonitorIcon',
          },
    {
    title: 'Проекты',
        route: 'projects',
            icon: 'BriefcaseIcon',
          },
    {
    title: 'Документы',
        route: 'docs',
            icon: 'FileIcon',
          },
  ]
